import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'semantic-ui-react';

import { useScreenConfig } from '../../config/screens.context';
import ClickmeetingAccessButton from '../ClickmeetingAccessButton';

export type LiveAccessButtonProps = {
  event?: {
    livePlatformPage?: string;
    [key: string]: unknown;
  };
  disabled?: boolean;
};

const LiveAccessButton: React.FC<LiveAccessButtonProps> = ({ event, disabled = false }) => {
  const { t } = useTranslation();
  const livePlatformPageConfig = useScreenConfig(event?.livePlatformPage ?? '');
  const livePlatformPath = livePlatformPageConfig?.path;

  if (!event) return null;

  if (livePlatformPath) {
    return (
      <Button
        as={Link}
        to={livePlatformPath}
        primary
        size="small"
        icon
        labelPosition="right"
        disabled={disabled}
      >
        <Icon name="arrow circle right" />
        {t('workshops.access-live', 'Accéder au live')}
      </Button>
    );
  }

  return <ClickmeetingAccessButton event={event} disabled={disabled} />;
};

export default LiveAccessButton;
